class ComponentAccordion extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();
    this.handleHashState();
    this.addDirectEvent('hashchange', window, this.handleHashState.bind(this));
  }

  toggleAccordion(detail, element) {
    const key = element.dataset.key;
    const isOpen = element.getAttribute('aria-expanded') === 'true';

    this.querySelectorAll('.accordion-item').forEach((item) => {
      const shouldOpen = item.querySelector('.accordion-header')?.dataset.key === key ? !isOpen : false;
      this.applyState(item, shouldOpen);
    });
  }

  handleHashState() {
    const key = window.location.hash.replace('#', '');

    if (!key) return;

    this.setAccordionState(key, true);
  }

  setAccordionState(activeKey, activeState) {
    this.querySelectorAll('.accordion-item').forEach((item) => {
      const btn = item.querySelector('.accordion-header');
      const shouldOpen = btn?.dataset.key === activeKey ? activeState : false;
      this.applyState(item, shouldOpen);
    });
  }

  applyState(item, open) {
    item.classList.toggle('is-active', open);
    const btn = item.querySelector('.accordion-header');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
}

customElements.define('component-accordion', ComponentAccordion);